import { Skeleton } from "@mui/material";
import React from "react";

const Text = () => {
  return <Skeleton variant="text" sx={{ fontSize: "2rem", width: "100%" }} />;
};

export default Text;
